
import { Fornitore } from "../Fornitore";
import { Utente } from "../utente/utente";
import { Posizione } from "./Posizione";

export interface Ordine {
	id:number;
	idUtenteCreazione: number;
	idUtenteUltimaModifica: number;
	dataCreazione: Date;
	dataUltimaModifica: Date;
	numeroOrdine: string;
	revisione: string;
	idIspettoreSnam: number;
	idUtenteInterno: number;
	idFornitore: number;
	stato: StatoOrdine;
	societa: string;
	tipoDocAcquisto: string;
	gruppoAcquisto:string;
	dataPrimoRilascio:Date;
	dataUltimoRilascio:Date;
	posizioni: Posizione[];
	numeroPosizioni:number;
	numeroPosizioniStatoEvaso:number;
	fornitore:Fornitore;
	ispettoreSnam:Utente;
	utenteInterno: Utente;
	urgenza:boolean;
	hashtag?:string;
}



  export enum StatoOrdine {
    NUOVO = 'NUOVO',
	LAVORATO = 'LAVORATO',
    REVISIONATO = 'REVISIONATO',
	CHIUSO= 'CHIUSO',
	CANCELLATO= 'CANCELLATO',
	NON_ASSEGNATO= 'NON ASSEGNATO',
	IN_MODIFICA = 'IN_MODIFICA'
  }
